module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_7_1.b12c9843.jpeg";